"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
const React = __importStar(require("react"));
const core_1 = require("@emotion/core");
const Theme_1 = require("orbiter-web-components/src/components/Theme");
const AnimatedButton_1 = __importDefault(require("orbiter-web-components/src/components/button/AnimatedButton"));
class Slot extends React.Component {
    render() {
        const smallMargin = (theme) => {
            return core_1.css `
                box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
                width: 100%;
                padding-top: 30px;
                padding-bottom: 30px;

                &:active{
                    background-color: ${Theme_1.applyTheme(theme, (t) => t.button.activeBackgroundColor)} !important;
                    border-color: ${Theme_1.applyTheme(theme, (t) => t.button.activeBorderColor)};
                    color: ${Theme_1.applyTheme(theme, (t) => t.button.textColor)} !important;
                }

                ${this.props.buttonStyle ? this.props.buttonStyle(theme) : ''}
            `;
        };
        return (core_1.jsx(AnimatedButton_1.default, Object.assign({}, this.props, { buttonStyle: smallMargin }),
            this.props.range.getStart().format("H"),
            ":",
            this.props.range.getStart().format("mm"),
            " - ",
            this.props.range.getEnd().format("H"),
            ":",
            this.props.range.getEnd().format("mm")));
    }
}
exports.default = Slot;
//# sourceMappingURL=Slot.js.map